import { cn } from '@/lib/utils';

interface DevEnvironmentBannerProps {
  /** When `true`, shows the DEV environment warning. When `false`, nothing is rendered. */
  isDev: boolean;
  /** Additional CSS classes. */
  className?: string;
}

/**
 * Prominent banner indicating the user is connected to the DEV environment.
 * Renders nothing when `isDev` is `false`.
 */
export function DevEnvironmentBanner({ isDev, className }: Readonly<DevEnvironmentBannerProps>) {
  if (!isDev) return null;

  return (
    <div className={cn('rounded-md bg-warning/10 border border-warning/30 p-4 text-sm text-warning font-medium', className)}>
      ⚠ DEV Environment — You are connected to the development Fabric workspace.
    </div>
  );
}
